<h1 translate>ERROR_PAGE_ACCESS_DENIED</h1>
<h2 translate>ERROR_PAGE_ACCESS_DENIED_TITLE</h2>
<p translate>ERROR_PAGE_ACCESS_DENIED_PARA</p>
<p>
  <a [routerLink]="['']" class="btn brand btn-outline" translate>ERROR_PAGE_RETURN_HOME</a>
</p>
